import { Component, OnInit } from '@angular/core';
import { ConnectionService } from './.services/connection.service'

declare var $:any;
declare var RTCMultiConnection:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor() {}

  ngOnInit() {
    $(document).foundation();
  }
}
